import {
  Button,
  CircularProgress,
  IconButton,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import classes from "./UserLandingPage.module.css";
import ProgressCard from "./ProgressCard";
import useTableFilter from "hooks/useTableFilter";
import useDateFilter from "hooks/useDateFilter";
import useFilter from "hooks/useFilter";
import Slider from "components/slider/Slider";
import { ROLES } from "constants/Constants";
import { Box } from "@mui/material";
import TanstackTable from "components/elements/advance-table/TanstackTable";
import actionIcon from "../../../assets/images/course/action-icon.svg";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { getConfigOrganization, fetchParticipationPerformance } from "ServerAPI/serverAPI";
import { useCookies } from "react-cookie";
import { ContentModalTable } from "components/dashboard/user-landing-page/courseModalTable";
import { CodeModal } from "components/dashboard/user-landing-page/codeModal";
import { toast } from "react-toastify";

const TrainingProgramProgress = ({
  rows,
  handleSearch,
  data,
  handleClick,
  loadingTable,
  selectedGroup,
  handleCourseChange,
  loadTableOnly,
  showTable,
  setShowTable,
  fetchOverAllData,
  setData,
  fixedData,
  activeTrainingProgramCard,
  setActiveTrainingProgramCard,
}) => {
  const [activeTab, setActiveTab] = useState(1);
  const [showCourseDropdown, setShowCourseDropdown] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [activeSlide, setActiveSlide] = useState(null);
  const [showQuizModal, setShowQuizModal] = useState(false);
  const [showContentModal, setShowContentModal] = useState(false);
  const [selectedUserContentData, setSelectedUserContentData] = useState({
    list: [],
    courseId: "",
    userId: ""
  });
  const [showCodeModal, setShowCodeModal] = useState(false);
  const [selectedCodeContent, setSelectedCodeContent] = useState(null);
  const [selectedCourseId, setSelectedCourseId] = useState("");
  const [loadingRows, setLoadingRows] = useState({});

  const { TableFilter } = useTableFilter(departments, "Chose Department", rows);
  const { DateFilter } = useDateFilter(data, setData, "Select Date");
  const { Filter } = useFilter(
    fixedData,
    setData,
    [
      { label: "INPROGRESS", value: "inProgress" },
      { label: "COMPLETED", value: "completed" },
    ],
    "Chose Status",
    "completed"
  );

  const [cookies] = useCookies();

  const overAllTabCols = [
    {
      accessorKey: "name",
      id: 1,
      header: () => (
        <span style={{ fontWeight: "bold", color: "#224D99" }}>Name</span>
      ),
      cell: ({ row }) => row?.original?.name || "Unknown",
    },
    {
      accessorKey: "overallProgress",
      id: 2,
      header: () => (
        <span style={{ fontWeight: "bold", color: "#224D99" }}>
          Progress (%)
        </span>
      ),
      cell: ({ row }) => row?.original?.overallProgress?.toFixed(2) || "0.00",
    },
  ];

  const individualCourseTabCols = [
    {
      accessorKey: "name",
      id: 1,
      header: () => (
        <span style={{ fontWeight: "bold", color: "#224D99" }}>Name</span>
      ),
      cell: ({ row }) => row?.original?.name || "Unknown",
    },
    {
      accessorKey: "courseProgress",
      id: 2,
      header: () => (
        <span style={{ fontWeight: "bold", color: "#224D99" }}>
          Progress (%)
        </span>
      ),
      cell: ({ row }) => row?.original?.courseProgress?.toFixed(2) || "0.00",
    },
    {
      accessorKey: "quizAttemptCount",
      id: 3,
      header: () => (
        <span style={{ fontWeight: "bold", color: "#224D99" }}>Attempts</span>
      ),
      cell: ({ row }) => row?.original?.quizAttemptCount || 0,
    },
    {
      accessorKey: "quizScore",
      id: 4,
      header: () => (
        <span style={{ fontWeight: "bold", color: "#224D99" }}>Score (%)</span>
      ),
      cell: ({ row }) => row?.original?.quizScore?.toFixed(2) || "0.00",
    },
    {
      accessorKey: "quizCompletionStatus",
      id: 5,
      header: () => (
        <span style={{ fontWeight: "bold", color: "#224D99" }}>Result</span>
      ),
      cell: ({ row }) => row?.original?.quizCompletionStatus || "-",
    },
    // {
    //   accessorKey: "time_taken",
    //   id: 6,
    //   header: () => (
    //     <span style={{ fontWeight: "bold", color: "#224D99" }}>Time Taken</span>
    //   ),
    //   cell: ({ row }) => row?.original?.time_taken || "-",
    // },
    {
      accessorKey: "viewContents",
      id: 7,
      header: () => (
        <span style={{ fontWeight: "bold", color: "#224D99" }}>View Contents</span>
      ),
      cell: ({ row }) => {
        const courseId = activeTab === 2 ? selectedCourseId : row.original.courseId;
        const userId = row.original.userId;
        const rowKey = `${userId}-${courseId}`;
        return (
          <div>
            <IconButton
              onClick={() => handleShowContentModal(row.original)}
              disabled={loadingRows[rowKey]}
            >
              {loadingRows[rowKey] ? (
                <CircularProgress size={24} />
              ) : (
                <img src={actionIcon} alt="view contents" />
              )}
            </IconButton>
          </div>
        );
      },
    },
  ];

  const handleShowContentModal = async (userRowData) => {
    const courseId = activeTab === 2 ? selectedCourseId : userRowData?.courseId;
    const userId = userRowData?.userId;
    const rowKey = `${userId}-${courseId}`;

    try {
      if (!courseId || !userId) {
        toast.error("Missing courseId or userId");
        return;
      }

      setLoadingRows((prev) => ({ ...prev, [rowKey]: true }));

      const payload = {
        courseId,
        userId,
        type: "courseProgress",
      };

      const response = await fetchParticipationPerformance(payload);

      if (response?.status === 200 && response?.data?.sections) {
        const contentData = [];

        response.data.sections.forEach((section) => {
          if (Array.isArray(section.content)) {
            section.content.forEach((content) => {
              const generatedContentId = content.contentId || `temp-${Math.random().toString(36).substr(2, 9)}`;
              contentData.push({
                contentId: generatedContentId,
                contentTitle: content.contentTitle || "Untitled",
                contentType: content.contentType || "Unknown",
                courseId,
                sectionId: section.sectionId || section._id || null,
                userId,
                completed: content.completed || false,
                teacherReviewed: content.teacherReviewed || false,
                quizResults: content.quizResults || null,
                attemptCount: content.attemptCount || 0,
                attempts: content.attempts || [],
                // Max-Attempts-specific fields — distinct from the general attemptCount/attempts
                // above. Previously omitted here, which silently starved courseModalTable.js's
                // Attempts column of data regardless of what the backend actually returned.
                isMaxAttemptsQuiz: content.isMaxAttemptsQuiz || false,
                maxAttempts: content.maxAttempts,
                maxAttemptsUsed: content.maxAttemptsUsed || 0,
                maxAttemptsHistory: content.maxAttemptsHistory || [],
                finalAssessment: content.finalAssessment || false,
                question: content.question,
                userAnswer: content.userAnswer,
                modelAnswer: content.modelAnswer,
                question_id: content.question_id,
              });
            });
          }
        });

        // PASS courseId and userId directly
        setSelectedUserContentData({
          list: contentData,
          courseId,
          userId
        });

        setShowContentModal(true);
      } else {
        toast.error("Failed to fetch course progress");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Error fetching progress");
    } finally {
      setLoadingRows((prev) => ({ ...prev, [rowKey]: false }));
    }
  };

  const handleCodeView = (content) => {
    if (!content.userId || !content.courseId || !content.contentId) {
      toast.error("Missing userId, courseId, or contentId for code content");
      console.error("Missing required fields for code view:", {
        userId: content.userId,
        courseId: content.courseId,
        contentId: content.contentId,
      });
      return;
    }

    console.log("handleCodeView called with contentId:", content.contentId);
    setShowContentModal(false);
    setSelectedCodeContent({ ...content, userId: content.userId });
    setShowCodeModal(true);
  };

  const handleCloseContentModal = () => {
    setShowContentModal(false);
    setSelectedUserContentData([]);
  };

  const handleViewContent = (contentId) => {
    if (!contentId) {
      toast.error("Invalid content ID");
      console.error("Invalid contentId in handleViewContent:", contentId);
      return;
    }
    console.log("View content with ID:", contentId);
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    if (tab === 1) {
      setShowTable(true);
      setShowCourseDropdown(false);
      setSelectedCourseId("");
    } else {
      setShowCourseDropdown(true);
      setShowTable(false);
      setSelectedCourseId("");
    }
  };

  const handleCourseChangeLocal = (event) => {
    const courseId = event.target.value;
    setSelectedCourseId(courseId);
    if (courseId) {
      handleCourseChange(event);
      setShowTable(true);
    } else {
      setShowTable(false);
      toast.warn("Please select a valid course");
    }
  };

  const getOrganizationDetail = async () => {
    if (!cookies?.email || !cookies?.organizationId || !cookies?.userId) {
      console.error("Missing cookie data for organization details");
      return;
    }
    const response = await getConfigOrganization(
      cookies.email,
      cookies.organizationId,
      cookies.userId
    );
    if (response.status === 200) {
      setDepartments(response?.data?.department || []);
    } else {
      console.error("Failed to fetch organization details:", response);
    }
  };

  useEffect(() => {
    getOrganizationDetail();
  }, [cookies?.email, cookies?.organizationId, cookies?.userId]);

  useEffect(() => {
    handleTabClick(1);
  }, [selectedGroup]);

  const handleSliderClick = (activeSlide) => {
    setActiveSlide(activeSlide);
  };

  const downloadExcel = async () => {
    if (activeTab === 1) {
      // Overall tab — simple styled export
      const workbook = new ExcelJS.Workbook();
      const sheet = workbook.addWorksheet("Overall Progress");

      // Header row
      sheet.columns = [
        { header: "Name", key: "name", width: 30 },
        { header: "Progress (%)", key: "progress", width: 18 },
      ];

      const headerRow = sheet.getRow(1);
      headerRow.eachCell((cell) => {
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF224D99" } };
        cell.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 12 };
        cell.alignment = { vertical: "middle", horizontal: "center" };
        cell.border = {
          top: { style: "thin" }, left: { style: "thin" },
          bottom: { style: "thin" }, right: { style: "thin" },
        };
      });
      headerRow.height = 22;

      (rows || []).forEach((row, i) => {
        const dataRow = sheet.addRow({
          name: row?.name || "Unknown",
          progress: row?.overallProgress?.toFixed(2) || "0.00",
        });
        const bgColor = i % 2 === 0 ? "FFF0F4FF" : "FFFFFFFF";
        dataRow.eachCell((cell) => {
          cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bgColor } };
          cell.alignment = { vertical: "middle", horizontal: "center" };
          cell.border = {
            top: { style: "thin", color: { argb: "FFD0D0D0" } },
            left: { style: "thin", color: { argb: "FFD0D0D0" } },
            bottom: { style: "thin", color: { argb: "FFD0D0D0" } },
            right: { style: "thin", color: { argb: "FFD0D0D0" } },
          };
        });
        dataRow.height = 18;
      });

      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), "overall-progress.xlsx");
    } else {
      // Individual Course tab — styled report with time_taken
      const workbook = new ExcelJS.Workbook();
      const sheet = workbook.addWorksheet("Individual Course Report");

      // Title banner
      sheet.mergeCells("A1:G1");
      const titleCell = sheet.getCell("A1");
      titleCell.value = "Individual Course Progress Report";
      titleCell.font = { bold: true, size: 14, color: { argb: "FFFFFFFF" } };
      titleCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF224D99" } };
      titleCell.alignment = { vertical: "middle", horizontal: "center" };
      titleCell.border = {
        top: { style: "medium" }, left: { style: "medium" },
        bottom: { style: "medium" }, right: { style: "medium" },
      };
      sheet.getRow(1).height = 28;

      // Column definitions
      sheet.columns = [
        { key: "sno",        width: 7  },
        { key: "name",       width: 30 },
        { key: "progress",   width: 18 },
        { key: "attempts",   width: 14 },
        { key: "score",      width: 16 },
        { key: "result",     width: 16 },
        { key: "time_taken", width: 20 },
      ];

      // Header row (row 2)
      const headers = ["S.No", "Name", "Progress (%)", "Attempts", "Score (%)", "Result", "Time Taken"];
      const headerRow = sheet.getRow(2);
      headers.forEach((h, idx) => {
        const cell = headerRow.getCell(idx + 1);
        cell.value = h;
        cell.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 11 };
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF1A3A6B" } };
        cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
        cell.border = {
          top: { style: "thin" }, left: { style: "thin" },
          bottom: { style: "thin" }, right: { style: "thin" },
        };
      });
      headerRow.height = 24;

      const formatTime = (timeInSeconds) => {
        if (timeInSeconds == null || timeInSeconds === "" || isNaN(timeInSeconds)) return "-";
        const totalSeconds = Math.round(Number(timeInSeconds));
        if (totalSeconds < 60) {
          return `${totalSeconds} seconds`;
        } else if (totalSeconds < 3600) {
          const minutes = Math.floor(totalSeconds / 60);
          const seconds = totalSeconds % 60;
          return `${minutes} minutes ${seconds} seconds`;
        } else {
          const hours = Math.floor(totalSeconds / 3600);
          const minutes = Math.floor((totalSeconds % 3600) / 60);
          const seconds = totalSeconds % 60;
          return `${hours} hours ${minutes} minutes ${seconds} seconds`;
        }
      };

      // Data rows starting at row 3
      (rows || []).forEach((row, i) => {
        const dataRow = sheet.getRow(i + 3);
        const values = [
          i + 1,
          row?.name || "Unknown",
          row?.courseProgress != null ? Number(row.courseProgress.toFixed(2)) : 0,
          row?.quizAttemptCount || 0,
          row?.quizScore != null ? Number(row.quizScore.toFixed(2)) : 0,
          row?.quizCompletionStatus || "-",
          formatTime(row?.time_taken),
        ];
        values.forEach((val, idx) => {
          const cell = dataRow.getCell(idx + 1);
          cell.value = val;
          cell.fill = {
            type: "pattern", pattern: "solid",
            fgColor: { argb: i % 2 === 0 ? "FFF0F4FF" : "FFFFFFFF" },
          };
          cell.alignment = { vertical: "middle", horizontal: idx === 1 ? "left" : "center" };
          cell.border = {
            top: { style: "thin", color: { argb: "FFD0D0D0" } },
            left: { style: "thin", color: { argb: "FFD0D0D0" } },
            bottom: { style: "thin", color: { argb: "FFD0D0D0" } },
            right: { style: "thin", color: { argb: "FFD0D0D0" } },
          };
        });
        dataRow.height = 18;
      });

      // Freeze panes: freeze title + header rows
      sheet.views = [{ state: "frozen", ySplit: 2 }];

      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(
        new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }),
        "individual-course-report.xlsx"
      );
    }
  };

  return (
    <>
      <ContentModalTable
        show={showContentModal}
        handleClose={handleCloseContentModal}
        contentData={selectedUserContentData}
        handleViewContent={handleViewContent}
        onCodeView={handleCodeView}
        showQuizModal={showQuizModal}
        setShowQuizModal={setShowQuizModal}
      />
      <CodeModal
        show={showCodeModal}
        handleClose={() => setShowCodeModal(false)}
        content={selectedCodeContent}
      />
      <Card>
        <Card.Body>
          <Card.Header className="px-0">
            <div className={classes.assessmentsHeader}>Training Program Progress</div>
          </Card.Header>
          <Row className="mt-5">
            {data.length > 0 ? (
              <Slider
                sliderData={[...data].sort((a, b) => new Date(b?.startDate?.$date || 0) - new Date(a?.startDate?.$date || 0))}
                Component={ProgressCard}
                handleClick={handleClick}
                slidesPerView={4}
                activeSlide={activeSlide}
                sliderOnClick={handleSliderClick}
              />
            ) : (
              <div>No training program found</div>
            )}
          </Row>
        </Card.Body>
      </Card>
      {loadingTable ? (
        <div className="d-flex justify-content-center mt-5">
          <CircularProgress />
        </div>
      ) : (
        <Card className="mt-5">
          <Card.Body>
            {activeTrainingProgramCard ? (
              <>
                <div className={classes.groupName}>{selectedGroup?.userGroupName || "No Group Selected"}</div>
                <div className="d-flex justify-content-between align-items-center">
                  <div className={classes.courseTabCon}>
                    <Button
                      className="transparent"
                      onClick={() => {
                        setShowTable(true);
                        setShowCourseDropdown(false);
                        handleTabClick(1);
                        setSelectedCourseId("");
                      }}
                      sx={{ background: activeTab === 1 ? "#FFFFFF" : "" }}
                    >
                      Overall
                    </Button>
                    <Button
                      className="transparent"
                      onClick={() => {
                        setShowTable(false);
                        setShowCourseDropdown(true);
                        handleTabClick(2);
                        setSelectedCourseId("");
                      }}
                      sx={{ background: activeTab === 2 ? "#FFFFFF" : "" }}
                    >
                      Individual Course
                    </Button>
                  </div>
                  <div className={`${showCourseDropdown ? "" : "d-none"}`}>
                    <select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={selectedCourseId}
                      onChange={handleCourseChangeLocal}
                      style={{ padding: "10px" }}
                    >
                      <option value="">Choose Course</option>
                      {(selectedGroup?.courseDetails || []).map((ele) => (
                        <option
                          key={ele?.courseId || `temp-${Math.random().toString(36).substr(2, 9)}`}
                          value={ele?.courseId}
                        >
                          {ele?.courseName || "Unknown Course"}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                {loadTableOnly ? (
                  <div className="d-flex mt-5 justify-content-center">
                    <CircularProgress />
                  </div>
                ) : (
                  <>
                    {showTable ? (
                      <>
                        <div className="mt-2">
                          <div className="d-flex justify-content-between">
                            <TextField
                              placeholder="Search Names"
                              inputProps={{ style: { height: "10px" } }}
                              onChange={handleSearch}
                            />
                            {([ROLES.PROGRAM_COORDINATOR, ROLES.ORGANIZATION_COORDINATOR].includes(cookies?.roleId)) && (
                              <Button
                                onClick={downloadExcel}
                                variant="contained"
                                sx={{
                                  fontSize: "0.75rem",
                                  padding: "2px 8px",
                                  minWidth: "auto",
                                  height: "30px",
                                  lineHeight: "1",
                                  backgroundColor: "rgb(34, 77, 153)",
                                  color: "#fff",
                                  "&:hover": {
                                    backgroundColor: "rgba(34, 77, 153, 0.85)",
                                  },
                                }}
                              >
                                Download Report
                              </Button>
                            )}
                          </div>
                        </div>
                        <div className="mt-2">
                          <Box>
                            <TanstackTable
                              columns={activeTab === 1 ? overAllTabCols : individualCourseTabCols}
                              data={rows || []}
                              pagination={true}
                            />
                          </Box>
                        </div>
                      </>
                    ) : (
                      <p className="mt-5">Please select a course above.</p>
                    )}
                  </>
                )}
              </>
            ) : (
              <p>Please select a training program</p>
            )}
          </Card.Body>
        </Card>
      )}
    </>
  );
};

export default TrainingProgramProgress;